import { Space, Tag } from "antd";
import type { FC } from "react";

import type { ValidationRule, ValidationType } from "../../../../../components/Form/types/types";

interface ValidationTagsProps {
    tags: ValidationRule[];
    onChange?: (inputValue: ValidationRule[]) => void;
    showClose?: boolean;
}

export const ValidationTags: FC<ValidationTagsProps> = ({ tags, onChange, showClose }) => {
    const removeObjectWithName = (arr: ValidationRule[], fieldName: ValidationType) => {
        const objWithNameIndex = arr.findIndex((obj) => obj.name === fieldName);
        if (objWithNameIndex > -1) {
            arr.splice(objWithNameIndex, 1);
        }
        return arr;
    };

    const onRemoveTag = (tagToRemove: ValidationRule) => {
        if (tags && onChange) {
            const newTags = removeObjectWithName(tags, tagToRemove.name);
            onChange(newTags);
        }
    };

    return (
        <Space size={[0, 8]} wrap>
            {tags.map((tag) => {
                return (
                    <Tag key={tag.name} closable={showClose} onClose={() => onRemoveTag(tag)}>
                        {tag.params ? `${tag.name} ${tag.params}` : tag.name}
                    </Tag>
                );
            })}
        </Space>
    );
};
